import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, concatMap, tap, map, withLatestFrom } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { Store } from '@ngrx/store';
import { AppState, IUniverseSelection } from './app.state';
import { CompanySearchService } from '../features/company-search/services/company-search.service';
import {
  changeActiveSideTab,
  changeActiveTab,
  loadSidenavData,
  submitSearch,
  navigateToResults,
  addTab,
  setActiveTab,
  setUniverseSelection,
} from './action';
import { GeneralInnovationActivityResultsService } from '../features/results/services/general-innovation-activity-results.service';

@Injectable({
  providedIn: 'root'
})
export class SearchEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private apiService: GeneralInnovationActivityResultsService,
    private store: Store<AppState>
  ) { }

  submitSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(submitSearch),
      switchMap(({ searchParams, searchType }) => {

        const newTabId = uuidv4();
        let params;
        let tab_name;
        let sideTab;
        let universeSelection: IUniverseSelection;
        if (searchType === 'company') {
          params = {
            entityids: [searchParams.companies[0].entityid],
            query: null,
            entity_data: searchParams.companies[0],
            query_data: null,
            //use the extended gsubind if it exists
            gsubind: [searchParams.companies[0].gsubind_extended || searchParams.companies[0].gsubind]
          };
          tab_name = searchParams.companies[0].entity_name;
          // set the default universe selection based on the company type
           universeSelection= {
            include_public: searchParams.companies[0].companytype === 'Public Company' || searchParams.companies[0].companytype === 'Public Investment Firm',
            include_private: searchParams.companies[0].companytype === 'Private Company',
            min_mcap: undefined,
            max_mcap: undefined
          };
          sideTab='executive_summary'
        } else if (searchType === 'theme') {
          universeSelection={
            include_public: true,
            include_private: false,
            min_mcap: undefined,
            max_mcap: undefined
          }
          params = {
            entityids: null,
            query: searchParams.themes[0].api_query,
            entity_data: null,
            query_data: searchParams.themes[0],
            gsubind: null
          };
          tab_name = searchParams.themes[0].category
            ? `${searchParams.themes[0].category} - ${searchParams.themes[0].name}`
            : searchParams.themes[0].name;
            sideTab='innovation_activity'


        } else {
          return of();
        }

        const newTab = {
          tabId: newTabId,
          search_type: searchType,
          params: params,
          sidenav_results: {},
          tab_name: tab_name,
          isLoading: false,
          universe: universeSelection
        };

        return of(
          addTab({ tab: newTab }),
          setUniverseSelection({ tabId: newTabId, selection: universeSelection }),
          changeActiveTab({ tabId: newTabId }),
          changeActiveSideTab({ sideTab: sideTab }),
          setActiveTab({ tab: newTab }),
          navigateToResults()
        );
      })
    )
  );
  navigateToResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navigateToResults),
      tap(() => {
        this.router.navigate(['/results']);
      })
    ),
    { dispatch: false }
  );


}
